const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('sycho-uikit', 'forum/components/DiscussionSearch');